import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/library/icons/mail-chat-bubble-square.svg
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 256 256"
};
function render(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M216 48H40a16 16 0 0 0-16 16v160a15.84 15.84 0 0 0 9.25 14.5A16.05 16.05 0 0 0 40 240a15.9 15.9 0 0 0 10.25-3.78l.09-.07L83 208h133a16 16 0 0 0 16-16V64a16 16 0 0 0-16-16m0 144H80a8 8 0 0 0-5.23 1.95L40 224V64h176Z" }, null, -1)])]);
}
var mail_chat_bubble_square_default = { render };
//#endregion
export { mail_chat_bubble_square_default as default, render };

//# sourceMappingURL=mail-chat-bubble-square.svg.js.map